import { UpdateIcon } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useEventJobRunning } from '../../hooks/useEventJobRunning';
import styles from './EventJobRunningBanner.module.scss';

export const EventJobRunningBanner = observer(() => {
  const { t } = useTranslation();
  const isRunning = useEventJobRunning();

  if (!isRunning) return null;

  // Zur Liste der Synchronisationen (Vertretungen › Einrichten › Synchronisation)
  const synchronizationsPath = `/${t('routes.substitutions.slug')}/${t('routes.setup.slug')}/${t('routes.synchronization.slug')}`;

  return (
    <div className={styles.banner}>
      <UpdateIcon className='svg-icon spinning' />
      {t('synchronizations.runningBanner')}
      <Link className={styles.link} to={synchronizationsPath}>
        {t('synchronizations.showSynchronizations')}
      </Link>
    </div>
  );
});

EventJobRunningBanner.displayName = 'EventJobRunningBanner';
